import TermsConditions from '../../containers/termsConditions/termsConditions';

const termsConditions = {
  path: '/terms-and-conditions',
  component: TermsConditions
};

export default termsConditions;
